import type { NeutralPalette } from '../schema/MiniPalette';

export const NEUTRAL_DARK_THEME_PALETTE: NeutralPalette = {
    black: '#ffffff',
    white: '#000000',
    whiteTranslucent50: 'rgba(33, 33, 33,.5)',
    blackTranslucent20: 'rgba(255, 255, 255,.2)',
    blackTranslucent50: 'rgba(255, 255, 255,.5)',
    blackTranslucent60: 'rgba(255, 255, 255,.6)',
    blackTranslucent90: 'rgba(255, 255, 255,.9)',

    textDominant: '#ffffff',
    textPrimary: '#e1e1e1',
    textSecondary: '#919191',
    textSecondaryHC: '#c8c8c8',
    textDisabled: '#404040',
    textOnAccent: '#000000',

    iconPrimary: '#ffffff',
    iconSecondary: '#6e6e6e',
    iconDisabled: '#404040',
    iconOnAccent: '#000000',

    surfacePrimary: '#000000',
    surfacePrimary2: '#212121',
    surfacePrimaryElevated: '#141414',
    surfaceSecondary: '#141414',
    surfaceTertiary: '#212121',
    surfaceQuaternary: '#404040',

    dividerPrimary: '#292929',
    dividerSecondary: '#303030',
    dividerTertiary: '#303030',
    dividerQuaternary: '#292929',

    overlay: 'rgba(0, 0, 0, 0.7)',

    omOpxBottomSheetBackground: '#212121',

    blue: '#0086F0',
    slateDark: '#3b3a39',

    successPrimary: '#0eb244',
    successShade20: '#3bc569',
    dangerPrimary: '#e83a3a',
    dangerShade20: '#ee6666',
    dangerTint30: '#461111',
    warningTint10: '#E0AB24',
    warningShade20: '#FFDD15',
    warningTint40: '#291F07',

    // Common
    headerForeground: '#ffffff',

    // Calendar
    rsvpBackground: '#292929',
    allInstancesEndBanner: '#828282',

    // Search
    searchHighlightBackground: '#302407',
    searchHighlightBorder: '#cfc708',

    // Brands
    teams: '#7A7FEA',
    skype: '#0078d4',

    // Mail
    mailSelectedBackground: '#141414',
    mailRPSubjectBackground: '#000000',
    mailRPBackground: '#000000',

    // People
    transparentDarkBg: '#141414',
    orgChartBorder: '#212121',
    orgChartPersonBg: '#001424',
    dividersPrimary: '#292929',

    // Onboarding cards
    carouselBg: '#000000',

    // Misc
    skeletonBg: '#a6a6a6',
    toastBg: '#0078d4',
    toggleBg: '#606060',

    // MeControl campaign card
    snackBarBg: '#c8c8c8',

    // USQ warning text
    warningText: '#ffc328',

    //NPS Button outline
    buttonOutlinePrimary: '#404040',
};
